//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const YdReturnQuery: any = {
    GetOrder: Backofficebff + '/ydmp/v1/order/getorder',
    ReturnOrder: Backofficebff + '/ydmp/v1/order/returnorder',
    GetMpOrigins: Backofficebff + '/ydmp/v1/lookup/getmporigins',
    GetPackageDetail: Backofficebff + '/ydmp/v1/order/GetPackageDetail',
};
